import { useState } from 'react';
import useMenuItems from './MenuItems.tsx';
import { useLocation } from 'react-router-dom';
import { Box, List, Button, Divider } from '@mui/material';
import { IconCalendarEvent } from '@tabler/icons-react';
import NavItem from './NavItem.tsx';
import { DemoRequestModal } from '@/features/demo-request/DemoRequestModal';

interface SidebarItemsProps {
  toggleMobileSidebar?: () => void;
}

const SidebarItems = ({ toggleMobileSidebar }: SidebarItemsProps) => {
  const { pathname } = useLocation();
  const menuItems = useMenuItems();
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  const handleClick = () => {
    if (toggleMobileSidebar) {
      toggleMobileSidebar();
    }
  };

  return (
    <Box sx={{ px: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
      <List sx={{ pt: 0 }} className="sidebarNav" component="div">
        {menuItems.map((item) => (
          <NavItem item={item} key={item.title} pathDirect={pathname} onClick={handleClick} />
        ))}
      </List>

      <Box sx={{ mt: 'auto', pb: 2 }}>
        <Divider sx={{ mb: 2 }} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<IconCalendarEvent size={18} />}
          onClick={() => setDemoModalOpen(true)}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: 2,
            py: 1.25,
            boxShadow: 3,
          }}
        >
          Solicitar demo
        </Button>
      </Box>

      <DemoRequestModal open={demoModalOpen} onClose={() => setDemoModalOpen(false)} />
    </Box>
  );
};

export default SidebarItems;
